var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uw"},[_c('h3',[_vm._v("Upload Widget Example")]),_c('button',{on:{"click":_vm.openUploadModal}},[_vm._v("Upload files")])])
}
var staticRenderFns = []

export { render, staticRenderFns }